import { reset } from 'redux-form';

import I18n from '../../config/i18n';

import { actionCreators as toastActions } from '../Toasts/actions';

import { stringArrayToObject } from '../../utils/array';

import { sendInvite } from '../../services/AccountService';

export const actions = stringArrayToObject(['START', 'SUCCESS', 'FAIL'], '@INVITE');

const privateActionCreators = {
  start() {
    return {
      type: actions.START,
    };
  },
  success(email) {
    return {
      type: actions.SUCCESS,
      payload: { email },
    };
  },
  fail(error) {
    return {
      type: actions.FAIL,
      payload: { error },
    };
  },
};

export const actionCreators = {
  inviteUser(data) {
    return async (dispatch) => {
      const response = await sendInvite(data);
      if (response.ok) {
        dispatch(privateActionCreators.success(data.email));
        dispatch(actionCreators.resetForm());
        dispatch(toastActions.addToast({
          type: 'success',
          message: I18n.t('screens.collaborators.invites.messages.success', data),
        }));
      } else {
        dispatch(privateActionCreators.fail(response.error));
        dispatch(toastActions.addToast({
          type: 'error',
          message: I18n.t('screens.collaborators.invites.errors.notSend', data),
        }));
      }
    };
  },
  resetForm() {
    return reset('inviteCollaboratorForm');
  },
};



// WEBPACK FOOTER //
// ./src/redux/Invite/actions.js